export const classifications: string[] = ["standstill", "fault", "slightImpairment", "generalInquiry"];
